const DashboardDecoration = () => (
    <svg
        width="964"
        height="350"
        viewBox="0 0 964 350"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{
            width: '100%',
            height: '100%',
        }}
        data-testid="dashboardDecoration"
    >
        <g clipPath="url(#clip0_370_45945)">
            <circle cx="221.989" cy="111.928" r="43.3279" fill="#FFCCBC" />
            <circle cx="169.032" cy="313.59" r="36.3741" fill="#FFCCBC" />
            <circle cx="31.8741" cy="11.8741" r="31.8741" fill="#B2EBF2" />
            <circle cx="446.118" cy="-5.21773" r="43.8628" fill="#E1BEE7" />
            <circle cx="840.348" cy="190.027" r="31.5598" fill="#E1BEE7" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M663.353 84.826C665.249 76.5531 662.331 67.335 654.724 63.5693L634.648 53.6301C627.035 49.8612 617.701 52.9574 614.972 61.0017C611.745 70.5153 609.76 80.4287 609.085 90.4956C608.065 105.691 610.049 120.938 614.922 135.367C619.795 149.796 627.462 163.124 637.486 174.589C647.51 186.055 659.694 195.434 673.342 202.191C686.991 208.948 701.837 212.95 717.032 213.97C732.227 214.989 747.475 213.006 761.904 208.133C776.332 203.26 789.66 195.593 801.126 185.569C808.722 178.928 815.402 171.339 821.01 163.004C825.753 155.957 822.556 146.657 814.943 142.888L800.362 135.67C792.756 131.904 783.656 135.172 778.227 141.696C776.006 144.365 773.572 146.861 770.946 149.157C764.432 154.852 756.859 159.208 748.661 161.977C740.463 164.746 731.8 165.873 723.167 165.293C714.533 164.714 706.098 162.44 698.343 158.601C690.589 154.762 683.666 149.433 677.971 142.919C672.276 136.404 667.919 128.832 665.151 120.634C662.382 112.436 661.255 103.773 661.834 95.139C662.068 91.6585 662.577 88.2104 663.353 84.826Z"
                fill="#FFE0B2"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M885.657 323.296C883.568 329.314 884.994 336.429 890.362 339.859L904.531 348.912C909.903 352.344 917.119 350.795 919.811 345.016C922.995 338.181 925.284 330.947 926.608 323.491C928.608 312.237 928.371 300.7 925.911 289.538C923.452 278.375 918.818 267.807 912.274 258.435C905.731 249.064 897.405 241.073 887.773 234.919C878.141 228.765 867.391 224.569 856.137 222.569C844.884 220.57 833.346 220.807 822.184 223.266C811.022 225.726 800.453 230.359 791.082 236.903C784.873 241.239 779.271 246.356 774.407 252.117C770.294 256.988 771.921 264.187 777.293 267.62L787.582 274.193C792.95 277.623 800.006 275.926 804.588 271.501C806.463 269.691 808.482 268.028 810.629 266.529C815.953 262.811 821.958 260.178 828.3 258.78C834.642 257.383 841.198 257.249 847.592 258.385C853.986 259.521 860.093 261.905 865.566 265.401C871.039 268.898 875.769 273.438 879.487 278.763C883.205 284.087 885.838 290.092 887.235 296.434C888.633 302.776 888.767 309.331 887.631 315.725C887.173 318.303 886.512 320.834 885.657 323.296Z"
                fill="#B2EBF2"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M274.936 326.476C273.175 331.552 274.38 337.553 278.908 340.444L290.861 348.075C295.394 350.969 301.48 349.66 303.748 344.785C306.432 339.02 308.36 332.917 309.475 326.629C311.158 317.136 310.956 307.405 308.878 297.991C306.801 288.578 302.889 279.665 297.367 271.763C291.845 263.86 284.821 257.123 276.695 251.935C268.57 246.747 259.502 243.211 250.01 241.528C240.517 239.845 230.786 240.048 221.372 242.125C211.958 244.202 203.046 248.114 195.143 253.636C189.908 257.294 185.184 261.612 181.083 266.472C177.616 270.582 178.99 276.653 183.522 279.547L192.203 285.089C196.731 287.98 202.682 286.547 206.545 282.813C208.126 281.286 209.828 279.883 211.638 278.618C216.128 275.48 221.192 273.258 226.541 272.078C231.89 270.897 237.418 270.782 242.812 271.739C248.205 272.695 253.357 274.704 257.974 277.652C262.591 280.599 266.582 284.427 269.719 288.917C272.856 293.407 275.079 298.471 276.259 303.819C277.439 309.168 277.555 314.697 276.598 320.09C276.213 322.265 275.656 324.4 274.936 326.476Z"
                fill="#E1BEE7"
            />
            <g clipPath="url(#clip1_370_45945)">
                <rect
                    x="685.936"
                    y="210.775"
                    width="179.432"
                    height="45.2348"
                    rx="22.6174"
                    transform="rotate(124.248 685.936 210.775)"
                    fill="#B2EBF2"
                />
            </g>
            <g clipPath="url(#clip2_370_45945)">
                <rect
                    x="888.092"
                    y="116.376"
                    width="179.432"
                    height="45.2348"
                    rx="22.6174"
                    transform="rotate(61.7832 888.092 116.376)"
                    fill="#FFCCBC"
                />
            </g>
            <g clipPath="url(#clip3_370_45945)">
                <rect
                    x="378.882"
                    y="-30.8406"
                    width="271.785"
                    height="68.5173"
                    rx="34.2587"
                    transform="rotate(58.0129 378.882 -30.8406)"
                    fill="#FFE0B2"
                />
            </g>
            <rect
                x="430.069"
                y="223.725"
                width="126.239"
                height="126.239"
                rx="10.6983"
                fill="#E1BEE7"
            />
            <rect
                x="67.1543"
                y="-9.68286"
                width="126.239"
                height="126.239"
                rx="10.6983"
                transform="rotate(7.7657 67.1543 -9.68286)"
                fill="#E1BEE7"
            />
            <rect
                x="422.14"
                y="326.648"
                width="141.169"
                height="35.5889"
                rx="17.7945"
                transform="rotate(-158.481 422.14 326.648)"
                fill="#FFE0B2"
            />
            <rect
                x="320.391"
                y="342.937"
                width="141.169"
                height="35.5889"
                rx="17.7945"
                transform="rotate(-68.4808 320.391 342.937)"
                fill="#FFE0B2"
            />
            <rect
                x="260.396"
                y="101.687"
                width="149.15"
                height="37.6007"
                rx="18.8004"
                transform="rotate(-103.31 260.396 101.687)"
                fill="#B2EBF2"
            />
            <rect
                x="184.872"
                y="23.2729"
                width="149.149"
                height="37.6007"
                rx="18.8004"
                transform="rotate(-13.3102 184.872 23.2729)"
                fill="#B2EBF2"
            />
            <rect
                x="163.441"
                y="274.184"
                width="154.687"
                height="38.9967"
                rx="19.4984"
                transform="rotate(-116.922 163.441 274.184)"
                fill="#B2EBF2"
            />
            <rect
                x="68.1738"
                y="213.577"
                width="154.687"
                height="38.9967"
                rx="19.4984"
                transform="rotate(-26.9222 68.1738 213.577)"
                fill="#B2EBF2"
            />
            <path
                d="M511.563 186.986C504.673 181.142 503.825 170.817 509.67 163.927L581.106 79.7114C586.951 72.8209 597.275 71.9732 604.165 77.8181C611.056 83.663 611.903 93.9871 606.059 100.878L534.623 185.093C528.778 191.984 518.454 192.831 511.563 186.986Z"
                fill="#FFCCBC"
            />
            <ellipse
                cx="516.584"
                cy="93.9812"
                rx="16.3604"
                ry="16.3604"
                transform="rotate(-49.6937 516.584 93.9812)"
                fill="#FFCCBC"
            />
            <ellipse
                cx="603.057"
                cy="168.13"
                rx="16.3604"
                ry="16.3604"
                transform="rotate(-49.6937 603.057 168.13)"
                fill="#FFCCBC"
            />
            <path
                d="M23.4436 344.59C16.7966 337.949 16.7918 327.177 23.4327 320.53L104.598 239.291C111.239 232.644 122.011 232.64 128.658 239.281C135.305 245.921 135.31 256.693 128.669 263.34L47.5036 344.58C40.8626 351.227 30.0906 351.231 23.4436 344.59Z"
                fill="#FFE0B2"
            />
            <ellipse
                cx="36.518"
                cy="248.621"
                rx="17.0129"
                ry="17.0129"
                transform="rotate(-45.026 36.518 248.621)"
                fill="#FFE0B2"
            />
            <ellipse
                cx="119.869"
                cy="332.789"
                rx="17.0129"
                ry="17.0129"
                transform="rotate(-45.026 119.869 332.789)"
                fill="#FFE0B2"
            />
            <rect
                x="561.658"
                y="22.5806"
                width="119.282"
                height="30.071"
                rx="15.0355"
                fill="#B2EBF2"
            />
            <rect
                x="681.479"
                y="0.925781"
                width="119.282"
                height="30.071"
                rx="15.0355"
                transform="rotate(180 681.479 0.925781)"
                fill="#B2EBF2"
            />
            <path
                d="M569.77 90.8575C570.27 94.3394 566.813 97.0566 563.547 95.7484L455.549 52.4809C452.283 51.1727 451.659 46.8204 454.424 44.6466L545.894 -27.2492C548.66 -29.423 552.742 -27.7878 553.241 -24.3059L569.77 90.8575Z"
                fill="#FFE0B2"
            />
            <path
                d="M293.687 104.826C316.493 83.5382 352.237 84.769 373.525 107.575C394.812 130.38 393.581 166.125 370.776 187.412L297.49 255.819C293.169 259.853 286.535 260.142 281.935 256.43C254.289 234.122 238.397 217.295 218.618 188.679C215.278 183.846 216.047 177.297 220.341 173.289L293.687 104.826Z"
                fill="#1E88E5"
            />
            <path
                d="M350.633 139.631C346.357 145.409 343.324 148.42 336.678 153.347"
                stroke="black"
                strokeWidth="5.95512"
                strokeLinecap="round"
            />
            <path
                d="M341.755 130.219C337.479 135.998 334.446 139.008 327.8 143.935"
                stroke="black"
                strokeWidth="5.95512"
                strokeLinecap="round"
            />
            <path
                d="M299.793 135.4C306.011 134.976 309.245 135.293 314.212 138.723"
                stroke="black"
                strokeWidth="4.02433"
                strokeLinecap="round"
            />
            <path
                d="M341.472 166.71C345.071 171.797 346.484 174.724 346.142 180.751"
                stroke="black"
                strokeWidth="4.02433"
                strokeLinecap="round"
            />
            <path
                d="M285.511 159.356L306.218 138.649C310.257 148.995 314.719 156.11 320.568 161.617C326.385 167.095 333.445 170.859 342.445 174.701L321.756 195.391C320.756 196.39 319.285 196.718 317.998 196.245C308.734 192.837 302.091 189.392 296.93 184.439C291.786 179.503 287.96 172.918 284.624 162.964C284.209 161.725 284.546 160.321 285.511 159.356Z"
                fill="black"
                stroke="black"
                strokeWidth="4.02433"
                strokeLinecap="round"
            />
            <path
                d="M361.177 197.983L374.089 185.93C397.52 164.057 398.784 127.331 376.911 103.9V103.9C355.038 80.4687 318.312 79.2055 294.881 101.078L281.969 113.132"
                stroke="black"
                strokeWidth="4.20566"
            />
            <path
                d="M285.558 93.0896C287.255 91.5046 289.917 91.5961 291.502 93.2941L298.389 100.672L272.565 124.779L265.677 117.401C264.092 115.703 264.184 113.042 265.882 111.457L285.558 93.0896Z"
                fill="black"
            />
            <path
                d="M361.676 214.075C359.978 215.66 357.317 215.568 355.732 213.87L348.844 206.492L374.668 182.385L381.556 189.764C383.141 191.462 383.049 194.123 381.352 195.708L361.676 214.075Z"
                fill="black"
            />
            <path
                d="M278.27 116.585C282.096 131.357 282.066 134.233 291.923 143.538M289.77 136.918L294.075 141.529L289.463 145.834L285.753 141.243L289.77 136.918Z"
                stroke="black"
                strokeWidth="2.5234"
            />
            <path
                d="M696.897 63.5788C677.71 38.9796 682.098 3.48397 706.697 -15.703C731.296 -34.89 766.792 -30.5025 785.979 -5.9034L846.413 71.5781C850.728 77.1102 850.294 84.9997 845.299 89.9259C821.869 113.03 803.954 126.99 775.411 144.411C769.411 148.073 761.636 146.579 757.313 141.036L696.897 63.5788Z"
                fill="#FFA726"
            />
            <path
                d="M736.69 8.9375C742.068 13.7073 744.799 16.9955 749.118 24.0505"
                stroke="black"
                strokeWidth="5.95512"
                strokeLinecap="round"
            />
            <path
                d="M726.531 16.9463C731.909 21.7161 734.639 25.0043 738.959 32.0593"
                stroke="black"
                strokeWidth="5.95512"
                strokeLinecap="round"
            />
            <path
                d="M795.747 3.59456L784.883 -10.3331C765.169 -35.6068 728.698 -40.1134 703.424 -20.3987V-20.3987C678.151 -0.68405 673.644 35.7863 693.359 61.0601L704.223 74.9877"
                stroke="black"
                strokeWidth="4.20566"
            />
            <path
                d="M684.577 69.6403C683.148 67.8089 683.475 65.1661 685.306 63.7375L693.265 57.5294L714.993 85.3847L707.035 91.5928C705.203 93.0214 702.56 92.6948 701.132 90.8634L684.577 69.6403Z"
                fill="black"
            />
            <path
                d="M811.821 4.52081C813.249 6.35224 812.923 8.99502 811.091 10.4236L803.132 16.6317L781.404 -11.2236L789.363 -17.4317C791.194 -18.8603 793.837 -18.5337 795.266 -16.7023L811.821 4.52081Z"
                fill="black"
            />
            <path
                d="M702.335 80.9775C717.387 78.4723 720.249 78.7566 730.389 69.7615M723.605 71.3202L728.579 67.4402L732.459 72.4143L727.558 75.7041L723.605 71.3202Z"
                stroke="black"
                strokeWidth="2.5234"
            />
            <path
                d="M730.153 60.089C725.459 54.0833 731.27 45.0989 738.865 44.4521C750.207 43.4862 756.665 37.6119 760.48 26.8323C763.349 18.725 774.315 15.4318 779.611 22.2079C784.44 28.3875 785.981 36.7494 782.467 43.761C775.719 57.2263 767.185 64.2556 751.299 68.1584C743.344 70.1128 735.197 66.5435 730.153 60.089Z"
                fill="black"
            />
            <path
                d="M616.531 198.377C614.314 202.06 612.521 204.269 609.54 207.081C609.179 207.421 609.125 207.979 609.421 208.377L615.171 216.112C615.577 216.658 616.406 216.627 616.751 216.04C620.02 210.479 620.602 206.264 618.282 198.572C618.04 197.771 616.963 197.66 616.531 198.377Z"
                fill="#FF8F00"
            />
            <circle cx="585.165" cy="220.482" r="31.9952" fill="#FF8F00" />
            <path
                d="M605.716 206.833L605.422 193.153C605.286 186.853 600.197 181.785 593.897 181.676L589.61 181.601C585.408 181.529 581.962 184.915 581.962 189.118V189.118"
                stroke="black"
                strokeWidth="1.88621"
            />
            <rect
                x="613.769"
                y="228.53"
                width="15.8654"
                height="22.7494"
                rx="3.72462"
                transform="rotate(178.214 613.769 228.53)"
                fill="black"
            />
            <circle
                cx="567.678"
                cy="211.129"
                r="3.55502"
                transform="rotate(7.86159 567.678 211.129)"
                fill="black"
            />
            <line
                x1="1.29274"
                y1="-1.29274"
                x2="6.46368"
                y2="-1.29274"
                transform="matrix(0.136787 -0.990601 0.990602 0.136774 567.897 218.99)"
                stroke="black"
                strokeWidth="2.58547"
                strokeLinecap="round"
            />
            <path
                d="M574.296 206.335C575.697 201.468 576.959 198.734 580.135 193.846"
                stroke="black"
                strokeWidth="4.19596"
                strokeLinecap="round"
            />
            <path
                d="M582.473 210.365C583.874 205.498 585.136 202.763 588.311 197.875"
                stroke="black"
                strokeWidth="4.19596"
                strokeLinecap="round"
            />
            <path
                d="M593.598 180.947C593.28 185.234 592.676 188.015 591.284 191.869C591.116 192.335 591.319 192.857 591.763 193.079L600.384 197.389C600.992 197.693 601.718 197.292 601.761 196.612C602.17 190.175 600.789 186.15 595.248 180.331C594.672 179.725 593.66 180.113 593.598 180.947Z"
                fill="#FF8F00"
            />
            <path
                d="M658.752 293.934C658.752 263.066 683.776 238.042 714.644 238.042C745.512 238.042 770.536 263.066 770.536 293.934V383.037C770.536 394.221 761.469 403.288 750.285 403.288H679.003C667.818 403.288 658.752 394.221 658.752 383.037V293.934Z"
                fill="#EF6C00"
            />
            <path
                d="M706.348 224.643C708.795 230.607 709.847 234.741 710.563 240.844C710.65 241.582 711.272 242.145 712.016 242.146L726.468 242.15C727.489 242.15 728.192 241.125 727.795 240.185C724.03 231.276 719.48 226.803 708.148 222.711C706.969 222.285 705.872 223.483 706.348 224.643Z"
                fill="#EF6C00"
            />
            <path
                d="M731.265 231.032C732.607 237.337 732.904 241.592 732.517 247.725C732.471 248.467 732.982 249.132 733.714 249.266L747.933 251.852C748.937 252.035 749.812 251.152 749.589 250.156C747.477 240.717 743.8 235.504 733.382 229.453C732.297 228.823 731.004 229.805 731.265 231.032Z"
                fill="#EF6C00"
            />
            <circle cx="688.229" cy="282.059" r="6.70119" fill="black" />
            <line
                x1="688.227"
                y1="294.242"
                x2="688.227"
                y2="284.495"
                stroke="black"
                strokeWidth="4.8736"
                strokeLinecap="round"
            />
            <path
                d="M682.732 263.922C682.732 265.686 683.209 267.984 682.11 269.398C681.834 269.752 680.116 272.517 681.713 271.761C684.082 270.639 686.601 269.477 688.477 267.601C689.414 266.663 690.244 265.631 691.137 264.686C691.905 263.873 691.576 265.101 691.844 265.705C692.262 266.644 691.168 269.525 692.538 269.525C694.168 269.525 696.036 267.525 696.938 266.356C697.474 265.661 698.082 264.865 698.495 264.092C698.643 263.814 699.032 262.998 699.032 263.314C699.032 264.215 699.585 265.14 699.938 265.945C700.31 266.797 700.751 267.662 701.126 268.506C701.389 269.098 700.734 270.431 701.381 270.431C702.625 270.431 705.9 268.016 706.418 266.851C706.549 266.556 706.94 265.175 707.182 265.054C707.204 265.043 708.096 266.62 708.201 266.78C708.621 267.423 709.287 268.11 709.46 268.888C709.512 269.121 709.405 270.747 709.616 270.657C711.066 270.036 712.865 269.889 714.059 268.761C715.111 267.767 716.096 266.825 716.096 265.351C716.096 265.19 716.212 265.68 716.351 265.761C716.669 265.948 717.103 266.216 717.37 266.469C717.909 266.978 718.257 267.593 718.587 268.252C718.891 268.86 721.7 270.497 721.7 269.398C721.7 268.082 721.7 266.766 721.7 265.45"
                stroke="black"
                strokeWidth="2.42295"
                strokeLinecap="round"
            />
            <path
                d="M770.939 289.223L770.175 270.846C768.906 240.326 743.794 216.237 713.248 216.237V216.237C681.781 216.237 656.271 241.747 656.271 273.214V298.354"
                stroke="black"
                strokeWidth="3.85914"
            />
            <path
                d="M645.175 283.323C645.175 281.191 646.903 279.463 649.034 279.463H658.296L658.296 311.88H649.034C646.903 311.88 645.175 310.152 645.175 308.021L645.175 283.323Z"
                fill="black"
            />
            <path
                d="M782.673 308.906C782.739 311.036 781.066 312.817 778.936 312.883L769.678 313.172L768.668 280.771L777.925 280.482C780.055 280.416 781.836 282.089 781.903 284.219L782.673 308.906Z"
                fill="black"
            />
            <rect
                x="960.767"
                y="93.4565"
                width="134.37"
                height="33.8747"
                rx="16.9373"
                transform="rotate(-165.698 960.767 93.4565)"
                fill="#E1BEE7"
            />
            <rect
                x="866.634"
                y="121.004"
                width="134.37"
                height="33.8747"
                rx="16.9373"
                transform="rotate(-75.6981 866.634 121.004)"
                fill="#E1BEE7"
            />
        </g>
        <defs>
            <clipPath id="clip0_370_45945">
                <rect width="964" height="350" rx="8" fill="white" />
            </clipPath>
            <clipPath id="clip1_370_45945">
                <rect
                    width="186.918"
                    height="60.0806"
                    fill="white"
                    transform="translate(539.689 329.257) rotate(-55.7518)"
                />
            </clipPath>
            <clipPath id="clip2_370_45945">
                <rect
                    width="186.918"
                    height="60.0806"
                    fill="white"
                    transform="translate(925.545 300.83) rotate(-118.217)"
                />
            </clipPath>
            <clipPath id="clip3_370_45945">
                <rect
                    width="283.125"
                    height="91.0043"
                    fill="white"
                    transform="translate(453.86 244.216) rotate(-121.987)"
                />
            </clipPath>
        </defs>
    </svg>
);

export default DashboardDecoration;
